// assets/filter-ui-enhancements.js
// Hiển thị số lượng sản phẩm cho mỗi tag, hiệu ứng loading khi filter, giữ trạng thái filter, và tối ưu UI filter


document.addEventListener('DOMContentLoaded', function() {
  // 1. Hiệu ứng loading khi click filter (vẫn giữ)
  var filterLinks = document.querySelectorAll('.productgrid--sidebar-item.filter-group a[href*="/collections/"]');
  filterLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      document.body.classList.add('filter-loading');
    });
  });

  // 2. Multi-select filter: build URL đúng chuẩn Shopify (collections/{handle}/{tag1+tag2}?view=...)
  filterLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var pathParts = window.location.pathname.split('/').filter(Boolean);
      var collectionIndex = pathParts.indexOf('collections');
      var collectionHandle = collectionIndex > -1 ? pathParts[collectionIndex + 1] : '';
      // Lấy tag hiện tại từ URL path (nếu có)
      var currentTags = [];
      if (pathParts.length > collectionIndex + 2) {
        currentTags = pathParts[collectionIndex + 2].split('+');
      }
      var tag = link.getAttribute('data-tag') || link.textContent.trim();
      var idx = currentTags.indexOf(tag);
      if (idx > -1) {
        currentTags.splice(idx, 1);
      } else {
        currentTags.push(tag);
      }
      // Xây lại URL path
      var newPath = '/collections/' + collectionHandle;
      if (currentTags.length > 0 && currentTags[0] !== '') {
        newPath += '/' + currentTags.join('+');
      }
      // Giữ lại toàn bộ query string (ví dụ: ?grid_list=grid-view)
      var search = window.location.search;
      var newUrl;
      if (search) {
        newUrl = newPath + (newPath.indexOf('?') === -1 ? search : '&' + search.slice(1));
      } else {
        newUrl = newPath;
      }
      document.body.classList.add('filter-loading');
      window.location = newUrl;
    });
  });

  // 3. Tìm kiếm nhanh tag (UI đẹp hơn)
  var filterGroup = document.querySelector('.productgrid--sidebar-item.filter-group');
  if (filterGroup && filterGroup.children.length > 10) {
    var searchWrap = document.createElement('div');
    searchWrap.className = 'filter-search-wrap';
    searchWrap.style.position = 'relative';
    searchWrap.style.display = 'flex';
    searchWrap.style.alignItems = 'center';
    searchWrap.style.background = '#f4f6fa';
    searchWrap.style.borderRadius = '8px';
    searchWrap.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
    searchWrap.style.padding = '10px 18px';
    searchWrap.style.marginBottom = '16px';
    searchWrap.style.border = '1px solid #e3e8ee';

    // SVG icon search
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.style.position = 'absolute';
    svg.style.left = '14px';
    svg.style.top = '50%';
    svg.style.transform = 'translateY(-50%)';
    svg.style.fill = '#b0b8c9';
    svg.innerHTML = '<circle cx="9" cy="9" r="7" stroke="#b0b8c9" stroke-width="2" fill="none"/><line x1="15" y1="15" x2="19" y2="19" stroke="#b0b8c9" stroke-width="2" stroke-linecap="round"/>';
    searchWrap.appendChild(svg);

    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = 'Search filters...';
    searchInput.className = 'filter-search-input';
    searchInput.style.flex = '1';
    searchInput.style.border = 'none';
    searchInput.style.background = 'transparent';
    searchInput.style.outline = 'none';
    searchInput.style.fontSize = '15px';
    searchInput.style.height = '15px';
    searchInput.style.lineHeight = '28px';
    searchInput.style.padding = '0 0 0 28px';
    searchInput.style.color = '#222';
    searchInput.style.transition = 'box-shadow 0.2s';
    searchInput.style.borderRadius = '8px';
    searchInput.style.fontWeight = '400';
    searchInput.style.letterSpacing = '0.01em';
    searchInput.addEventListener('focus', function() {
      searchInput.style.boxShadow = '0 0 0 2px #b0b8c9';
    });
    searchInput.addEventListener('blur', function() {
      searchInput.style.boxShadow = 'none';
    });
    searchInput.addEventListener('input', function() {
      var val = this.value.toLowerCase();
      filterGroup.querySelectorAll('li').forEach(function(li) {
        var text = li.textContent.toLowerCase();
        li.style.display = text.indexOf(val) > -1 ? '' : 'none';
      });
    });
    searchWrap.appendChild(searchInput);
    filterGroup.parentNode.insertBefore(searchWrap, filterGroup);
  }
});

// CSS gợi ý (thêm vào theme.scss hoặc theme.scss.liquid):
// .filter-search-wrap { width: 100%; margin-bottom: 10px; display: flex; align-items: center; background: #f8f8f8; border-radius: 6px; box-shadow: 0 1px 4px rgba(0,0,0,0.03); padding: 4px 8px; }
// .filter-search-input { flex: 1; border: none; background: transparent; outline: none; font-size: 15px; padding: 8px 0; }
// .filter-search-input::placeholder { color: #aaa; font-style: italic; }
// body.filter-loading::after { content: ''; position: fixed; left:0;top:0;right:0;bottom:0; background:rgba(255,255,255,0.5) url('/assets/loading.gif') center center no-repeat; z-index:9999; }
